import { render, staticRenderFns } from "./edit_receipt.vue?vue&type=template&id=4faf4209&scoped=true"
import script from "./edit_receipt.vue?vue&type=script&lang=js"
export * from "./edit_receipt.vue?vue&type=script&lang=js"
import style0 from "./edit_receipt.vue?vue&type=style&index=0&id=4faf4209&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faf4209",
  null
  
)

export default component.exports